import { render, staticRenderFns } from "./index.vue?vue&type=template&id=363a5543&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=363a5543&lang=sass"
import style1 from "./index.vue?vue&type=style&index=1&id=363a5543&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a5543",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363a5543')) {
      api.createRecord('363a5543', component.options)
    } else {
      api.reload('363a5543', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=363a5543&scoped=true", function () {
      api.rerender('363a5543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/index.vue"
export default component.exports